import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import {injectIntl} from 'react-intl';
import messages from '../../../../../../res/translations/messages';
import Operator from '../Operator';
import Value from '../Value';
import QuestionId from '../QuestionId';

class MultipleChoiceBuilder extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {expression, intl} = this.props;

        let operator;
        switch (expression.condition.operator) {
            case constants.EDITOR_OPERATORS.IN:
                operator = intl.formatMessage({...messages.filters.operators.contains});
                break;
            case constants.EDITOR_OPERATORS.NOT_IN:
                operator = intl.formatMessage({...messages.filters.operators.notContains});
                break;
        }

        if (!operator) {
            return null;
        }

        return (
            <>
                <QuestionId id={expression.id} />
                <Operator operator={operator} />
                <Value value={expression.condition.value} />
            </>
        );
    }
}

export default injectIntl(MultipleChoiceBuilder);
